import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface LoadMoreButtonProps {
  onLoadMore: () => void;
  loading: boolean;
}

export const LoadMoreButton = ({ onLoadMore, loading }: LoadMoreButtonProps) => {
  return (
    <div className="flex justify-center mt-12">
      <Button
        onClick={onLoadMore}
        disabled={loading}
        className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white border-0 rounded-full px-8 py-3 text-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300"
      >
        {loading ? (
          <>
            <Loader2 className="w-5 h-5 mr-2 animate-spin" />
            Loading...
          </>
        ) : (
          "Load more events"
        )}
      </Button>
    </div>
  );
};